let before;
let now;
let fps;
let isRunning = false;
function runLoop() {
    if (!isRunning)
        return;
    now = Date.now();
    fps = Math.round(1000 / (now - before));
    before = now;
    requestAnimationFrame(runLoop);
}
export function startFpsTracker() {
    isRunning = true;
    before = Date.now();
    fps = 0;
    runLoop();
}
export function stopFpsTracker() {
    isRunning = false;
}
export function getCurrentFps() {
    return fps;
}
